import React from "react";
import { Container } from "react-bootstrap";

export default function Footer({ user }) {
  const userName = localStorage.getItem("user");
  return (
    <footer className="bg-light border-top mt-4 py-3">
      <Container className="d-flex justify-content-between align-items-center">
        <span className="text-muted">
          © {new Date().getFullYear()} SimpleBooks App
        </span>
        <span className="fw-semibold">
          Logged in as: {userName ? userName : "Guest"}
        </span>
      </Container>
    </footer>
  );
}
